import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'
import { SessionFragment } from 'generated/resources/graphql'
import moment from 'moment'

interface Props {
  firstSession: SessionFragment
  trainingName: string
  sessionUrl: string
}

export const Row = ({ firstSession, trainingName, sessionUrl }: Props) => (
  <Box
    alignItems="center"
    justifyContent="spaceBetween"
    borderRadius={{ all: 'abs008' }}
    border={{
      all: {
        width: 's1',
        style: 'solid',
        color: 'grey400',
      },
    }}
    flexDirection="row"
    paddingX="s24"
    paddingY="s16"
  >
    <Box flexDirection="row" gap="s16" alignItems="center">
      <Icon.Large icon="calendar-clock" color="radicalRed1000" />
      <Text.Normal size="300" weight="medium">
        {trainingName} - {firstSession.name}
      </Text.Normal>
    </Box>
    <Text.Normal>{moment(firstSession.startsAt).format('L HH:mm').toLocaleString()}</Text.Normal>
    <Text.Normal>{moment(firstSession.endsAt).format('L HH:mm').toLocaleString()}</Text.Normal>
    <Button.Router to={sessionUrl} type="secondary" iconName="arrow-right" />
  </Box>
)
